<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { ButtonColor, ButtonVariant } from "~~/models/buttons";
import type { SplitItemRecord, SplitSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "~~/models/buttons";

const props = defineProps<{ data: SplitSectionRecord }>();

const localePath = useLocalePath();

const itemList = computed(() => props.data.items.map((i: SplitItemRecord) => {
  const v = i.optLinkItemStyle?.variant;
  const variant = BUTTON_VARIANTS.includes(v as ButtonVariant) ? (v as ButtonVariant) : "link";

  const c = i.optLinkItemStyle?.color;
  const color = BUTTON_COLORS.includes(c as ButtonColor) ? (c as ButtonColor) : "primary";

  return {
    id: i.id,
    text: i.text,
    linkItem: getLinkForType(i.optLinkItem, localePath),
    linkItemStyle: {
      variant: variant,
      color: color,
    },
    image: i.optImage,
  };
}));
</script>

<template>
  <div class="mb-3xl lg:mb-5xl gap-lg md:gap-3xl grid grid-cols-1 md:grid-cols-2">
    <div v-for="item in itemList" :key="item.id" class="gap-xl p-md md:p-xl flex flex-col bg-[#F3F1EC]">
      <div class="html-content">
        <div v-html="item.text" />

        <p v-if="item.linkItem.to">
          <UButton
            :variant="item.linkItemStyle.variant"
            :color="item.linkItemStyle.color"
            :ui="{ base: 'leading-7' }"
            :to="item.linkItem.to"
            :target="item.linkItem.target ?? '_self'"
            class="structured-button"
          >
            {{ item.linkItem.label }}
          </UButton>
        </p>
      </div>

      <div class="group overflow-hidden">
        <DatocmsImage
          v-if="item.image" :data="item.image.responsiveImage as ResponsiveImageType" object-fit="cover"
          class="rounded-sm transition-transform duration-300 ease-in-out group-hover:scale-105"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
